export default class Traces {
  client

  constructor(client) {
    this.client = client
  }

  trace(params) {
    return this.client.post("/api/v2/tracing/trace", params)
  }

  performance_traces(params) {
    return this.client.post("/api/v2/tracing/traces/performance", params)
  }

  performance_trace(params) {
    return this.client.post("/api/v2/tracing/trace/performance", params)
  }

  error_traces(params) {
    return this.client.post("/api/v2/tracing/traces/errors", params)
  }

  error_trace(params) {
    return this.client.post("/api/v2/tracing/trace/error", params)
  }

  actions(params) {
    return this.client.post("/api/v2/tracing/actions", params)
  }

  locator(params) {
    return this.client.post("/api/v2/tracing/locator", params)
  }

  slow_events(params) {
    return this.client.post("/api/v2/tracing/slow_events", params)
  }

  slow_events_actions(params) {
    return this.client.post("/api/v2/tracing/slow_events/actions", params)
  }

  metadata_distributions(params) {
    return this.client.post("/api/v2/tracing/metadata_distributions", params)
  }

  search(params) {
    return this.client.post("/api/v2/search", params)
  }
}
